import { render } from "./keyboard.vue?vue&type=template&id=08b0a7a0"
import script from "./keyboard.vue?vue&type=script&lang=js"
export * from "./keyboard.vue?vue&type=script&lang=js"

import "./keyboard.vue?vue&type=style&index=0&id=08b0a7a0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__